import { auth, database } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { ref, push, get } from "firebase/database";

export async function loginWithEmail(email, password) {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  return userCredential.user;
}

export async function checkAdminStatus(email) {
  const sanitizedEmail = email.replace(/\./g, "-");
  const adminRef = ref(database, `data/settings/admins/${sanitizedEmail}`);
  const snapshot = await get(adminRef);
  return snapshot.exists() && snapshot.val() === true;
}

export async function logFailedLoginAlert(userEmail, count) {
  const alertRef = ref(database, "alerts/failedLogins");
  const alertData = {
    email: userEmail,
    timestamp: new Date().toISOString(),
    message: `User has failed to log in ${count} times.`,
  };
  
  try {
    await push(alertRef, alertData);
    console.log("Alert sent to Firebase successfully.");
  } catch (error) {
    console.error("Error sending alert to Firebase:", error);
  }
}
